import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../redux/authSlice";
import {
  Home,
  User,
  ShoppingCart,
  Bell,
  LogOut,
  Shield,
  Heart,
  HelpCircle,
  X,
} from "lucide-react";
import "../assets/css/sidebar.css";

const Sidebar = ({ isOpen, closeSidebar }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { cartItems } = useSelector((state) => state.cart);
  const sidebarRef = useRef(null);

  // ✅ Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        closeSidebar();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, closeSidebar]);

  return (
    <>
      {/* Overlay background */}
      <div
        className={`sidebar-overlay ${isOpen ? "show" : ""}`}
        onClick={closeSidebar}
      />

      {/* Sidebar container */}
      <aside
        ref={sidebarRef}
        className={`sidebar ${isOpen ? "open" : ""}`}
        style={{
          background: "linear-gradient(180deg, #b30000 0%, #7a0000 100%)",
          color: "white",
        }}
      >
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="fw-bold m-0 text-light">Dashboard</h5>
          <button
            className="btn btn-sm text-white"
            style={{ fontSize: 22 }}
            onClick={closeSidebar}
          >
            <X size={22} />
          </button>
        </div>

        {/* Links */}
        <div className="sidebar-content flex-grow-1 overflow-auto">
          <nav className="d-flex flex-column gap-2">
            <Link to="/" className="sidebar-link" onClick={closeSidebar}>
              <Home size={20} />
              <span>Home</span>
            </Link>

            <Link to="/help" className="sidebar-link" onClick={closeSidebar}>
              <HelpCircle size={20} />
              <span>Help & FAQs</span>
            </Link>

            <Link to="/contact" className="sidebar-link" onClick={closeSidebar}>
              <HelpCircle size={20} />
              <span>Contact Us</span>
            </Link>

            {user ? (
              <>
                <Link
                  to="/cart"
                  className="sidebar-link position-relative"
                  onClick={closeSidebar}
                >
                  <ShoppingCart size={20} />
                  <span>Cart</span>
                  {cartItems?.length > 0 && (
                    <span className="cart-badge">{cartItems.length}</span>
                  )}
                </Link>

                <Link
                  to="/orders"
                  className="sidebar-link"
                  onClick={closeSidebar}
                >
                  <ShoppingCart size={20} />
                  <span>Orders</span>
                </Link>

                <Link
                  to="/wishlist"
                  className="sidebar-link"
                  onClick={closeSidebar}
                >
                  <Heart size={20} />
                  <span>Wishlist</span>
                </Link>

                <Link
                  to="/notifications"
                  className="sidebar-link"
                  onClick={closeSidebar}
                >
                  <Bell size={20} />
                  <span>Notifications</span>
                </Link>

                {user.role === "admin" && (
                  <>
                    <div className="text-uppercase small text-warning mt-4 mb-1">
                      Admin Panel
                    </div>
                    <Link
                      to="/admin"
                      className="sidebar-link"
                      onClick={closeSidebar}
                    >
                      <Shield size={20} />
                      <span>Admin Panel</span>
                    </Link>
                  </>
                )}

                <button
                  onClick={() => {
                    dispatch(logoutUser());
                    closeSidebar();
                  }}
                  className="sidebar-link text-danger"
                  style={{ background: "transparent", border: "none" }}
                >
                  <LogOut size={20} />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="sidebar-link text-success"
                onClick={closeSidebar}
              >
                <User size={20} />
                <span>Login</span>
              </Link>
            )}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;